/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:52:57]
Permissions to update outside the main branch: [false]
*/

import { Filter } from '@finbeat/react-toolkit';
import { AxiosInstance } from 'axios';
import {
    DeclinedShowcase,
    DeclinedShowcaseAdd,
    DeclinedShowcaseChange,
    DeclinedShowcaseTable,
} from 'models/api/declinedShowcase';
import ResTable from 'models/api/table';

const controller = '/declinedshowcases';

export const getDeclinedShowcasesList = async (
    axios: AxiosInstance,
    params?: Filter<DeclinedShowcase>
) => {
    const response = await axios.get<ResTable<DeclinedShowcaseTable>>(controller, { params });
    return response.data;
};

export const getDeclinedShowcasesExcel = async (
    axios: AxiosInstance,
    params: Filter<DeclinedShowcase>
) => {
    const { data } = await axios.get<Blob>(controller + '/excel', {
        responseType: 'arraybuffer',
        params: { ...params },
    });
    return data;
};

export const addDeclinedShowcase = async (axios: AxiosInstance, item: DeclinedShowcaseAdd) =>
    await axios.post<DeclinedShowcase>(controller, item);

export const changeDeclinedShowcase = async (
    axios: AxiosInstance,
    item: DeclinedShowcaseChange
) => {
    await axios.put<DeclinedShowcase>(controller + `/${item.id}`, item);
};

export const deleteDeclinedShowcase = async (axios: AxiosInstance, id: number | string) =>
    await axios.delete(controller + `/${id}`);

export const getDeclinedShowcase = async (axios: AxiosInstance, id: number | string) => {
    const response = await axios.get<DeclinedShowcase>(controller + `/${id}`);
    return response.data;
};
